<template>
  <div class="page-guide">
    <weui-group v-if="!coach.name">
      <weui-input label="称呼" v-model="name" placeholder="请输入您的称呼" />
    </weui-group>
    <weui-group>
      <weui-switch v-if="!firstLogin" label="每节课前提醒我" v-model="notify_before_course" />
      <weui-switch label="允许用户查看我的日程安排" v-model="course_time_publicly" />
    </weui-group>
    <weui-group tips="您还可以在“我”页面，随时改变上述设置" />
    <weui-button-area>
      <weui-button class="confirm-btn" type="primary" @click="confirm">确定</weui-button>
    </weui-button-area>
  </div>

</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import { WeuiGroup, WeuiInput, WeuiButton, WeuiButtonArea, WeuiSwitch } from '@/components/weui';
import { FETCH_COACH, PATCH_COACH } from '@/store/coach/types';
import { ROUTE_LOGIN } from '@/router/names';

const { mapState: mapAuthState } = createNamespacedHelpers('auth');
const { mapState: mapCoachState, mapActions: mapCoachActions } = createNamespacedHelpers('coach');

export default {
    data() {
        return {
            name: '--',
            notify_before_course: true,
            course_time_publicly: false,
        };
    },
    computed: {
        ...mapAuthState([
            'brand_new',
        ]),
        ...mapCoachState({
            coach: state => state.coach || {},
        }),
        firstLogin() {
            return !this.brand_new && !this.coach.wechat_visited;
        },
        skipRequired() {
            // 未设置名称
            if (!this.coach.name) {
                return false;
            }
            // 第一次登录
            if (this.firstLogin) {
                return false;
            }
            return true;
        },
    },
    watch: {
        coach(val) {
            if (val) {
                this.name = val.name;
                this.notify_before_course = val.notify_before_course;
                this.course_time_publicly = val.course_time_publicly;
            }
        },
    },
    async created() {
        await this.apiFetch();
        if (this.skipRequired) {
            this.forward();
        }
        // 非第一次登录用户
        this.apiPatch({
            wechat_visited: true,
        });
    },
    methods: {
        ...mapCoachActions({
            apiFetch: FETCH_COACH,
            apiPatch: PATCH_COACH,
        }),
        forward() {
            this.$router.replace({
                name: ROUTE_LOGIN,
            });
        },
        confirm() {
            this.apiPatch({
                name: this.name,
                notify_before_course: this.notify_before_course,
                course_time_publicly: this.course_time_publicly,
            })
                .then(() => {
                    this.forward();
                });
        },
    },
    components: {
        WeuiGroup,
        WeuiInput,
        WeuiButton,
        WeuiButtonArea,
        WeuiSwitch,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/login/Guide.vue